module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('h2', [_vm._v("Signing you in...")]), _vm._v(" "), _c('Loading'), _vm._v(" "), (_vm.slow) ? _c('p', [_vm._v("\n    This is taking longer than usual. "), _c('a', {
    staticClass: "link",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("Go back")])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3de5e4e3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/OAuthCallback.vue
// module id = 374
// module chunks = 1